import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuiz } from '../contexts/QuizContext';
import { motion } from 'framer-motion';

const Loading = () => {
  const { loading, diagnosis, generateDiagnosis } = useQuiz();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Inicia o processo de geração do diagnóstico
    if (!diagnosis) {
      generateDiagnosis();
    }
    
    // Quando o diagnóstico estiver pronto, redireciona para a página de oferta
    if (!loading && diagnosis) {
      const timer = setTimeout(() => {
        navigate('/offer');
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [loading, diagnosis, generateDiagnosis, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="max-w-md mx-auto md:max-w-2xl p-8 text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Analisando suas respostas...</h2>
        
        <div className="loading-animation">
          <motion.div 
            className="loading-circle"
            animate={{ 
              rotate: 360,
              borderColor: [
                'rgba(59, 130, 246, 0.5)', // blue-500 com opacidade
                'rgba(16, 185, 129, 0.5)', // green-500 com opacidade
                'rgba(245, 158, 11, 0.5)', // amber-500 com opacidade
                'rgba(239, 68, 68, 0.5)',  // red-500 com opacidade
                'rgba(59, 130, 246, 0.5)'  // volta para blue-500
              ]
            }}
            transition={{ 
              rotate: { repeat: Infinity, duration: 2, ease: "linear" },
              borderColor: { repeat: Infinity, duration: 4 }
            }}
          >
            <motion.div 
              className="loading-inner-circle"
              animate={{ 
                scale: [1, 1.2, 1],
                backgroundColor: [
                  'rgba(59, 130, 246, 0.8)', // blue-500
                  'rgba(16, 185, 129, 0.8)', // green-500
                  'rgba(245, 158, 11, 0.8)', // amber-500
                  'rgba(239, 68, 68, 0.8)',  // red-500
                  'rgba(59, 130, 246, 0.8)'  // volta para blue-500
                ]
              }}
              transition={{ 
                scale: { repeat: Infinity, duration: 1.5 },
                backgroundColor: { repeat: Infinity, duration: 4 }
              }}
            />
          </motion.div>
        </div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
        >
          <p className="text-gray-600 mt-6">
            Estamos preparando um diagnóstico personalizado para o seu negócio...
          </p>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2, duration: 0.5 }}
        >
          <p className="text-gray-600 mt-4">
            Identificando os principais pontos de melhoria...
          </p>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 3, duration: 0.5 }}
        >
          <p className="text-gray-600 mt-4">
            Preparando recomendações específicas para o seu caso...
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Loading;
